import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const romaneioReportPdf = async (reportData) => {
  try {
    const report = await api.post('/reports/romaneio/pdf',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'application/pdf' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const romaneioReportCsv = async (reportData) => {
  try {
    const report = await api.post('/reports/romaneio/csv',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'text/csv' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const estoqueReportPdf = async (reportData) => {
  try {
    const report = await api.post('/reports/estoque/pdf',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'application/pdf' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const estoqueReportCsv = async (reportData) => {
  try {
    const report = await api.post('/reports/estoque/csv',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'text/csv' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const ticketReportPdf = async (romaneioId) => {
  try {
    const report = await api.get('/reports/ticket', {
      params: { id: romaneioId },
      responseType: 'blob',
      headers: setAuthHeader(),
    });
    
    const blob = new Blob([report.data], { type: 'application/pdf' });
    downloadBlob(blob);
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao gerar relatório.');
  }
};

export const transferReportPdf = async (transferId) => {
  try {
    const report = await api.get('/reports/transfer', {
      params: { id: transferId },
      responseType: 'blob',
      headers: setAuthHeader(),
    });
    
    const blob = new Blob([report.data], { type: 'application/pdf' });
    downloadBlob(blob);
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao gerar relatório.');
  }
};

export const saldosReportPdf = async (reportData) => {
  try {
    const report = await api.post('/reports/balance/pdf',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'application/pdf' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const saldosReportCsv = async (reportData) => {
  try {
    const report = await api.post('/reports/balance/csv',
      reportData,
      {
        responseType: 'blob',
        headers: setAuthHeader(),
      }
    );
    
    const blob = new Blob([report.data], { type: 'text/csv' });
    downloadBlob(blob);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao gerar relatório.');
  }
};

export const downloadBlob = (blob) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('target', '_blank');
  link.click();
  window.URL.revokeObjectURL(url);
};